import { useState, useEffect } from 'react';

export const useLiveFeedback = ({
  initialMessage = '',
  delay = 1000,
}: {
  initialMessage?: string;
  delay?: number;
}) => {
  const [message, setMessage] = useState(initialMessage);

  useEffect(() => {
    if (!message) return;

    const clearTimer = setTimeout(() => {
      setMessage('');
    }, delay);

    return () => clearTimeout(clearTimer);
  }, [message, delay]);

  return [message, setMessage] as const;
};
